<div class="flex items-center etoll-param">
    <div
        class="self-end w-4.5 h-4.5" 
        [ngClass]="{
            'tk-i-eToll-status-unregistered' : (isSentGeo ? (data.SG === 2) : (data.ES === 0)),
            'tk-i-eToll-status-disabled' : (isSentGeo ? (data.SG === 2) : (data.ES === 1)),
            'tk-i-eToll-status-enabled' : (isSentGeo ? (data.SG === 1) : (data.ES === 2)),
            'tk-i-eToll-status-error' :  (isSentGeo ? (data.SG === 3) : (data.ES === 3)),
            'tk-i-eToll-status-deleyed' : (isSentGeo ? (data.SG === 4) : (data.ES === 4))
        }"
    ></div>
</div>
